import { ReactElement } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { Checkbox } from '@hopskipdrive/react-components';

import { StyledCheckboxField, StyledFormLabel } from '../IncidentForm.styles';

interface AccountBlockFieldProps {
  defaultValue?: boolean;
}

export const AccountBlockField = ({ defaultValue }: AccountBlockFieldProps): ReactElement => {
  const { control } = useFormContext();
  const { field } = useController({
    name: 'accountBlock',
    control,
    defaultValue,
  });

  return (
    <StyledCheckboxField display="flex" alignItems="center">
      <Checkbox
        name="accountBlock-checkbox"
        id="accountBlock-checkbox"
        checked={field.value}
        onClick={() => field.onChange(!field.value)}
      />
      <StyledFormLabel htmlFor="accountBlock-checkbox">
        Driver blocked (from impacted account&apos;s service)
      </StyledFormLabel>
    </StyledCheckboxField>
  );
};
